// Helper Meta Pixel (browser). Il PageView iniziale è già in index.html.
const rid = () => (crypto?.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random());

export const newEventId = (kind) => `${kind}_${rid()}`;

export function track(eventName, params = {}, eventId = newEventId(eventName)) {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", eventName, params, { eventID: eventId });
    }
  } catch (e) { /* no-op */ }
  return eventId;
}

export function trackCustom(eventName, params = {}, eventId = newEventId(eventName)) {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("trackCustom", eventName, params, { eventID: eventId });
    }
  } catch (e) { /* no-op */ }
  return eventId;
}

export function trackPageView() {
  return track("PageView");
}
